import React, { Suspense } from "react";

const AppImpl = React.lazy(() => import("../pdfedit-pro-live.jsx"));

export default function App() {
  return (
    <Suspense fallback={null}>
      <AppImpl />
    </Suspense>
  );
}
